export default __webpack_public_path__ + "static/media/footerBanner.d52a5319.jpg";